import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { Description, GroupSelect, LediumForm, TitleAndDescription, UniqueName } from '@ledium/ui-common';
import { Container } from '@mui/material';

import SpectrumMixerChannelSettings from './Components/SpectrumMixerChannelSettings';
import SpectrumMixerChart from './Components/SpectrumMixerChart';
import SpectrumMixerDetailedIntensityInfo from './Components/SpectrumMixerDetailedIntensityInfo';
import SpectrumMixerLightChannelSelect from './Components/SpectrumMixerLightChannelSelect';
import SpectrumMixerSelectLightRecipe from './Components/SpectrumMixerSelectLightRecipe';
import SpectrumMixerSettings from './Components/SpectrumMixerSettings';

interface SpectrumMixerViewProps {
    onSave: () => void;
    onClose: () => void;
}

const SpectrumMixerView = ({ onSave, onClose }: SpectrumMixerViewProps) => {
    const {
        pageState: { formData }
    } = usePageStore();
    return (
        <Container>
            <LediumForm onSubmit={() => onSave()} onCancel={onClose} header={<TitleAndDescription />}>
                <UniqueName />
                <Description />
                <SpectrumMixerSelectLightRecipe />

                <GroupSelect
                    label={i18n('select_group_of_the_lighting_devices')}
                    disabled={!!(formData.lightChannels as unknown[]).length}
                    disabledMessage={i18n('spectrum_mixer_disabled_tree_selection')}
                />
                <SpectrumMixerLightChannelSelect filterByGroup noItemsMessage={i18n('spectrum_mixer_no_light_in_group')} />

                <SpectrumMixerSettings />
                <SpectrumMixerChannelSettings />
                <SpectrumMixerChart />
                <SpectrumMixerDetailedIntensityInfo />
            </LediumForm>
        </Container>
    );
};

export default SpectrumMixerView;
